<template>
    <div >
        <div class="flex">
            <el-date-picker
                    style="width: 220px"
                    class="marr4"
                    size="small"
                    v-model="valuetime"
                    @change="getTimes"
                    :clearable="false"
                    type="daterange"
                    :range-separator="$t('saleInvoicing_to')"
                    :start-placeholder="$t('saleInvoicing_start_date')"
                    :end-placeholder="$t('saleInvoicing_end_date')">
            </el-date-picker>
            <!--<div class="flex w50 alc">
                <span class="marr4 font14 minW58">关联公司</span>
                <el-select @change="changeData($event,'glgs')" @clear="clearsearch('glgs')" class="marr4" v-model="i_iskp" size="mini" clearable filterable placeholder="请选择关联公司是否开票">
                    <el-option
                            v-for="item in GLdata"
                            :key="item.i_id"
                            :label="item.vc_name"
                            :value="item.i_id">
                    </el-option>
                </el-select>
            </div>
            <div class="flex w50 alc">
                <span class="marr4 font14 minW58">关联销售单</span>
                <el-select @change="changeData($event,'glxsd')" @clear="clearsearch('glxsd')" class="marr4" v-model="i_isforeign" size="mini" clearable filterable placeholder="请选择关联公司是否开票">
                    <el-option
                            v-for="item in GLxsddata"
                            :key="item.i_id"
                            :label="item.vc_name"
                            :value="item.i_id">
                    </el-option>
                </el-select>
            </div>-->
            <el-input
                    style="width: 220px"
                    class="marr4"
                    size="small"
                    :placeholder="$t('saleInvoicing_search')"
                    suffix-icon="el-icon-search"
                    @change="gosearch"
                    v-model="vc_search">
            </el-input>
            <el-button :class="baseerp+'btn'"  size="mini" type="primary" @click="openAdd">{{$t('saleInvoicing_new')}}</el-button>
        </div>
        <!--@selection-change="handleSelectionChange"-->
        <el-table
                border
                ref="multipleTable"
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%"
                v-loading="loading2"
                size="mini"
                :height="tableHeight"
                :header-cell-style="{background:'#eef1f6',color:'#000'}"
                :highlight-current-row="highlightCurrentRow">
            <!--<el-table-column
                    type="selection"
                    width="55">
            </el-table-column>-->
            <el-table-column
                    type="index"
                    width="50">
            </el-table-column>
            <el-table-column
                    prop="vc_xcode"
                    :label="$t('saleInvoicing_sales_order_number')"
                    min-width="120">
            </el-table-column>
            <el-table-column
                    prop="vc_gsname"
                    :label="$t('saleInvoicing_customer')"
                    show-overflow-tooltip
                    min-width="150">
            </el-table-column>
            <el-table-column
                    prop="vc_pzname"
                    :label="$t('saleInvoicing_variety')"
                    show-overflow-tooltip
                    min-width="155">
            </el-table-column>
            <el-table-column
                    prop="f_pendingnum"
                    :label="$t('saleInvoicing_pre_release_quantity')"
                    show-overflow-tooltip
                    min-width="100">
            </el-table-column>
        </el-table>
        <div>
            <!--<el-pagination
                    class="flex_e padT6"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page.sync="currentPage"
                    :page-sizes="[20, 30, 50]"
                    :page-size="pageSize"
                    layout="sizes, prev, pager, next"
                    :total="tableTotal">
            </el-pagination>-->
            <!--<div class="flex_b alc">
                <div>
                    {{'已选'+ ' '+multipleSelection.length+' '+'条'}}
                </div>
                <el-button :class="baseerp+'btn'"  size="small"  @click="sure">确定</el-button>
                &lt;!&ndash;<div class="flex alc">
                    <div class="marr4">
                        <div style="color: #9e9e9e;font-size: 12px">{{'开票总额'}}</div>
                        <div>{{totalPrice}}</div>
                    </div>
                    <el-button :class="baseerp+'btn'"  size="small" type="primary">确定</el-button>
                </div>&ndash;&gt;
            </div>-->
        </div>
        <el-dialog
                :class="baseerp+'div'"
                width="1000px"
                :title="$t('saleInvoicing_add_new_pre_outbound')"
                :visible.sync="dialogVisible_add"
                :close-on-click-modal="false"
                @close="cancelDialog_add"
                v-if="dialogVisible_add"
                :append-to-body="true">
            <add-yck ref="addYck" :addyckData="addyckData"  @close="cancelDialog_add" ></add-yck>
        </el-dialog>
    </div>
</template>
<script>
    import * as API from "./api"
    import {baseerp} from "@/utils/baseUrl";
    import addYck from "./addYck";
    export default {
        name: "",
        components: {
            addYck
        },
        props:{
            addData:{
                type:Object,
                required:true,
            }
        },
        data(){
            return{
                i_isforeign:null,
                GLxsddata:[{i_id:null,vc_name:this.$t('saleInvoicing_all')},{i_id:0,vc_name:this.$t('saleInvoicing_domestic')},{i_id:1,vc_name:this.$t('saleInvoicing_foreign_countries')}],
                i_iskp:null,
                GLdata:[{i_id:null,vc_name:this.$t('saleInvoicing_all')},{i_id:0,vc_name:this.$t('saleInvoicing_uninvoiced')},{i_id:1,vc_name:this.$t('saleInvoicing_invoiced')}],
                baseerp:"",
                mid:0,
                title:this.$t('saleInvoicing_new_invoice_issuance'),
                dialogVisible_add:false,
                dialogVisible_sheet:false,
                dialogVisible_yck:false,
                addyckData:{},
                i_gsid:0,
                loading2:true,
                vc_search:"",
                highlightCurrentRow:false,
                pageSize:20,
                currentPage:1,
                tableTotal:0,
                valuetime:'',
                dt_startdate:'',
                dt_enddate:'',
                tableData: [],
                multipleSelection: [],
                multipleSelection_2:[],
                tableHeight:400,
            }
        },

        mounted() {
            //console.log("sessionStorage.getItem('mids')",sessionStorage.getItem('mids'))
            this.baseerp=baseerp;
            //console.log('data',this.addData);
            this.i_gsid = this.addData.row.i_gsid;
            this.getfMou();

        },
        beforeDestroy() {
            window.removeEventListener('resize', this.updateTableHeight);
        },
        methods:{
            updateTableHeight() {
                //console.log(this.addData.maxDialogHeight,'this.addData.maxDialogHeight');
                const dialogHeight = this.addData.maxDialogHeight * 0.95; // 弹窗最大高度
                //console.log(dialogHeight,' dialogHeight');
                const otherHeight =450;
                this.tableHeight = dialogHeight - otherHeight;
                //console.log( this.tableHeight,' this.tableHeight')
                this.maxDialogHeight =  this.addData.maxDialogHeight;
            },
            changeData(e, type) {
                if (type == 'glgs') {
                    this.i_iskp = e;
                }
                if (type == 'glxsd') {
                    this.i_isforeign = e;
                }
            },
            clearsearch(type) {
                if (type == 'glgs') {
                    this.i_iskp = null;
                }
                if (type == 'glxsd') {
                    this.i_isforeign = null;
                }
            },
            openAdd(){
                this.addyckData={
                    item:this.addData.row,
                    maxDialogHeight:this.addData.maxDialogHeight,
                };
                this.dialogVisible_add=true;
            },
            cancelDialog_add(val){
                this.addyckData={};
                this.dialogVisible_add=false;
                if(val=='new'){
                    this.$emit('success');
                    //this.$emit('close')
                    this.currentPage=1;
                    this.tableData=[];
                    this.getList();
                    this.addData.row.f_kycknum=0;
                }
            },
            handleSelectionChange(val) {
                //console.log(val,'val')
                this.multipleSelection = val;
                this.multipleSelection_2 = [...this.multipleSelection_2 , ...val];
            },
            gosearch(){
                //console.log("搜索",this.vc_search);
                //console.log("公司",this.companyId);
                this.currentPage=1;
                this.tableData=[];
                this.getList();
            },

            handleSizeChange(val){
                this.pageSize=val;
                this.currentPage=1;
                this.getList();
            },
            handleCurrentChange(val){
                this.currentPage=val;
                this.getList();
            },
            //列表list
            async getList(){
                this.loading2=true;
                let param={
                    'i_mid':this.mid,
                    "vc_xcode":this.addData.row.vc_xcode,
                    "vc_no":this.addData.row.vc_no,
                    "i_pzid":this.addData.row.i_pzid,
                    //"i_gsid": this.i_gsid,
                    //"vc_search": this.vc_search,
                    //"currentPage":this.currentPage,
                    //"pageSize": this.pageSize,
                    //'dt_startdate':this.dt_startdate,
                    //'dt_enddate':this.dt_enddate,
                };
                var res = await API.getPendingShipmentList(param);
                if (res.code==1){
                    this.tableData=res.data;
                    this.tableTotal=res.total;
                    this.loading2=false;
                    this.updateTableHeight();
                    window.addEventListener('resize', this.updateTableHeight);
                    // console.log('this.multipleSelection_2',this.multipleSelection_2)
                }else if (res.code == -2) {
                    this.loading2=false;
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.loading2=false;
                    this.$message.error(res.message);
                }
            },
            //获取当前月的第一天
            getfMou(){
                let today = new Date();
                let firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
                // console.log(firstDay,today);
                let map = [firstDay,today];
                this.valuetime=map;
                // console.log(this.valuetime)
                this.dt_startdate= this.formatDate( this.valuetime[0]);
                this.dt_enddate= this.formatDate( this.valuetime[1]);
                this.getList();
            },
            formatTen(num) {
                return num > 9 ? (num + "") : ("0" + num);
            },
            formatDate(date) {
                var year = date.getFullYear();
                var month = date.getMonth() + 1;
                var day = date.getDate();
                var hour = date.getHours();
                var minute = date.getMinutes();
                var second = date.getSeconds();
                return year + "-" + this.formatTen(month) + "-" + this.formatTen(day);
            },
            getTimes(e){
                // console.log(e)
                if(e){
                    this.dt_startdate= this.formatDate(e[0]);
                    this.dt_enddate= this.formatDate(e[1]);
                    // console.log(this.dt_startdate,this.dt_enddate);
                }else{
                    this.dt_startdate= '';
                    this.dt_enddate= '';
                }
                this.currentPage=1;
                this.tableData=[];
                this.getList();
            },



        },
    }
</script>


<style  lang="scss" scoped>
    /deep/.el-table td{

    }
    .green{
        background-color: green !important;
    }
    .boxyu{
        background-color: #fa5050;
        border-radius: 4px;
        padding: 1px 4px;
        color: #fff;
        font-size: 14px;
    }
    .boxbu{
        width: 38px;
        height: 28px;
        line-height: 25px;
    }
    .box{
        width: 24px;
        height: 24px;
        line-height: 24px;
    }
    .cgdia {
        //弹出层里内容 样式
        /deep/.el-dialog__body {
            max-height: 85vh !important;
            overflow-y: auto;
            padding: 6px !important;
        }

    }

    .flex_e{
        display: flex;
        justify-content: end;
    }
    .mar9{
        margin: 9px;
    }
    .alc{
        align-items: center;
    }
    .flex{
        display: flex;
    }
    .flex_b{
        display: flex;
        justify-content: space-between;
    }
    .fr{
        float: right;
    }
    .mrr9{
        margin-right: 9px;
    }
    .padT6{
        //padding: 6px 0;
    }
    .pad14{
        padding: 6px;
    }
    .w100{
        width: 100%;
    }
    .marr4{
        margin-right: 4px;
    }



</style>
